import { useEffect } from "react";

const HISTORY_MARKER = "stock-shooter-detail";

export function useMobileBackButton(detailOpen: boolean, onBack: () => void): void {
  useEffect(() => {
    if (!detailOpen) return;
    window.history.pushState({ [HISTORY_MARKER]: true }, "");
    const handler = (e: PopStateEvent) => {
      if (!e.state || !e.state[HISTORY_MARKER]) onBack();
    };
    window.addEventListener("popstate", handler);
    return () => {
      window.removeEventListener("popstate", handler);
      if (window.history.state && window.history.state[HISTORY_MARKER]) {
        window.history.back();
      }
    };
  }, [detailOpen, onBack]);
}
